/* ---------------------------------------------------------------------------
   The waitlist form, PW-55. Inline, not a popup.

   The same plumbing as wx-optin.js, cut down to one step: the public Klaviyo
   client endpoint for the list and the consent record, the Meta pixel Lead and
   the wiseOS Conversions API Lead under one shared event id, and the view and
   submit counts to our own counter. Read wx-optin.js for why each of those
   exists; the reasons are not repeated here.

   A page carries this form twice (the opening scene and the close). Every
   instance is wired, and a join in one flips all of them to the joined state,
   so a person who scrolls down after joining is not asked again.

   NO SECRETS HERE. company_id is the public site ID that already ships in the
   storefront script. There is no API key in this file and there must never be.
   --------------------------------------------------------------------------- */
// Films: a visitor who asked for less motion gets a still with controls, not
// a loop. Runs on its own because the form code below can exit early.
(function () {
  try {
    if (!window.matchMedia || !matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('DOMContentLoaded', function () {
      [].forEach.call(document.querySelectorAll('.wx-wl-film__v'), function (v) {
        v.removeAttribute('autoplay'); v.pause(); v.controls = true;
      });
    });
  } catch (e) { /* motion preference is a nicety, never a failure */ }
})();

(function () {
  'use strict';
  if (window.__wxWlLoaded) return;
  window.__wxWlLoaded = true;

  var roots = [].slice.call(document.querySelectorAll('[data-wx-wl]'));
  if (!roots.length) return;

  var first = roots[0].dataset;
  var cfg = {
    company: first.company, list: first.list, lp: first.lp || '', form: first.form || '',
    collect: first.collect || '', capi: first.capi || '', client: first.client || ''
  };
  if (!cfg.company || !cfg.list) return;      // unconfigured is invisible, not broken

  var K = 'https://a.klaviyo.com/client';
  var REV = '2025-07-15';
  var JOINED = 'wx_wl_joined_' + cfg.list;

  var source = (function () {
    try {
      var q = new URLSearchParams(location.search);
      var out = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) {
        var v = q.get(k);
        if (v) out[k] = String(v).slice(0, 60);
      });
      if (q.get('fbclid')) out.paid_click = 'meta';
      if (q.get('gclid')) out.paid_click = 'google';
      if (!out.utm_source && !out.paid_click) out.utm_source = document.referrer ? 'referral' : 'direct';
      return out;
    } catch (e) { return {}; }
  })();

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* fine */ } }

  function anonId() {
    var a = get('wx_anon');
    if (!a) {
      a = 'wx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      set('wx_anon', a);
    }
    return a;
  }

  function collect(event, props) {
    if (!cfg.collect) return;
    var body = Object.assign({
      event: event, form: cfg.form, lp: cfg.lp, visitor: anonId(), page: location.pathname,
      // Same rule as wx-optin.js: ?wx_test=1, headless Chrome, or an unpublished theme.
      test: /[?&]wx_test=1/.test(location.search) || /HeadlessChrome/.test(navigator.userAgent) ||
        !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') || undefined,
    }, source, props || {});
    try {
      fetch(cfg.collect, {
        method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      }).catch(function () { /* analytics must never block a signup */ });
    } catch (e) { /* nor break one */ }
  }

  function metaLead(eventId) {
    try {
      if (typeof window.fbq !== 'function') return;
      window.fbq('track', 'Lead', { content_name: cfg.form, content_category: 'waitlist' }, { eventID: eventId });
    } catch (e) { /* a blocked pixel is not our problem to solve */ }
  }

  function metaCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function capiLead(eventId, email) {
    if (!cfg.capi || !cfg.client) return;
    try {
      var fbc = metaCookie('_fbc');
      if (!fbc) {
        var fbclid = (location.search.match(/[?&]fbclid=([^&#]+)/) || [])[1];
        if (fbclid) fbc = 'fb.1.' + Date.now() + '.' + decodeURIComponent(fbclid);
      }
      fetch(cfg.capi, {
        method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          client: cfg.client, email: email, event_id: eventId,
          fbp: metaCookie('_fbp') || undefined, fbc: fbc || undefined,
          url: location.href.split('#')[0], form: cfg.form, lp: cfg.lp,
        }),
      }).catch(function () { /* tracking never blocks a signup */ });
    } catch (e) { /* nor breaks one */ }
  }

  function subscribe(email) {
    var props = { wx_source: 'wx-waitlist', wx_lp: cfg.lp, wx_form: cfg.form };
    if (source.utm_source) props.wx_utm_source = source.utm_source;
    if (source.utm_campaign) props.wx_utm_campaign = source.utm_campaign;
    if (source.paid_click) props.wx_paid_click = source.paid_click;
    return fetch(K + '/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REV },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email, anonymous_id: anonId(), properties: props,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: cfg.list } } }
        }
      })
    }).then(function (r) {
      if (r.status === 202) return { ok: true };
      return r.json().catch(function () { return {}; }).then(function (d) {
        var detail = d && d.errors && d.errors[0] && (d.errors[0].detail || d.errors[0].title);
        return { ok: false, message: detail || ('Klaviyo returned ' + r.status) };
      });
    });
  }

  function joined() {
    roots.forEach(function (r) { r.classList.add('is-joined'); });
  }
  if (get(JOINED)) joined();

  // One view per page load, counted when the first form is actually on screen,
  // so a visitor who bounces from the top of the page is not a form view.
  var viewed = false;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !viewed) { viewed = true; collect('viewed'); io.disconnect(); }
      });
    }, { threshold: 0.4 });
    roots.forEach(function (r) { io.observe(r.querySelector('form') || r); });
  }

  // The clock. One interval for every clock on the page; each hides itself
  // when it reaches zero rather than sitting at 00 00 00 00.
  var clocks = [].slice.call(document.querySelectorAll('[data-wx-wl-clock]'));
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Date.now() / 1000;
    clocks.forEach(function (c) {
      var left = Math.max(0, Math.floor(Number(c.dataset.to) - now));
      if (!left) { c.hidden = true; return; }
      var u = { d: Math.floor(left / 86400), h: Math.floor(left % 86400 / 3600), m: Math.floor(left % 3600 / 60), s: left % 60 };
      Object.keys(u).forEach(function (k) {
        var el = c.querySelector('[data-u="' + k + '"]');
        if (el) el.textContent = pad(u[k]);
      });
    });
  }
  if (clocks.length) { tick(); setInterval(tick, 1000); }

  roots.forEach(function (root) {
    var form = root.querySelector('form');
    var msg = root.querySelector('[data-wx-wl-msg]');
    function say(t, bad) {
      if (!msg) return;
      msg.textContent = t || '';
      msg.classList.toggle('is-error', !!bad);
    }
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type=email]');
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { say('That email does not look right.', true); input.focus(); return; }
      var btn = form.querySelector('button');
      btn.disabled = true; say('');
      subscribe(email).then(function (res) {
        btn.disabled = false;
        if (!res.ok) { say(res.message, true); return; }
        set(JOINED, String(Date.now()));
        set('wx_email', email);
        var eid = 'wx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        collect('submitted', { step: 1 });
        metaLead(eid);
        capiLead(eid, email);
        joined();
        var done = root.querySelector('[data-wx-wl-done]');
        if (done) { done.setAttribute('tabindex', '-1'); done.focus({ preventScroll: true }); }
        // Klaviyo knows this browser from now on, so the visit to the product
        // page that follows is recorded against the profile (Viewed Product).
        try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
        // Forward to the pre-order page (Lau, 7 Oct): the joined state shows
        // first, then the visitor can secure a piece at once. collect() and
        // capiLead() use keepalive, so the server Lead still reaches Meta.
        var fwd = (root.getAttribute('data-forward') || '').trim();
        if (fwd && /^\/[^\/]/.test(fwd)) setTimeout(function () { window.location.href = fwd; }, 1800);
      }).catch(function () {
        btn.disabled = false;
        say('That did not go through. Try again in a moment.', true);
      });
    });
  });
})();
